import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import "./ReviewListManuIcon.scss";
import SubMenuThreeDotIcon from "../../../../../components/icons/SubMenuThreeDotIcon";
import toast from "react-hot-toast";
import CancelModal from "./CancelModal";
import DeleteModal from "./DeleteModal";
import { Modal } from "@mui/material";
import { PropertyApi } from "../../../../../utils/api/Property";

const ReviewListManuIcon = ({
  onViewDetails,
  onEdit,
  onConfirmPost,
  onPostNow,
  onPreview,
  onCancel,
  onDelete,
  previewImageUrl,
  onUpdated,
}: {
  onViewDetails?: () => void;
  onEdit?: () => void;
  onConfirmPost?: () => void;
  onPostNow?: () => void;
  onPreview?: () => void;
  onCancel?: () => void;
  onDelete?: () => void;
  previewImageUrl?: string;
  onUpdated?: () => void;
}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [isCancelModalOpen, setIsCancelModalOpen] = React.useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const downloadImagePreview = (imageUrl: string) => {
    if (!imageUrl) return;
    const relativePath = imageUrl.replace(/^.*\/design-tool\/images\//, "");
    const downloadUrl = `https://designtoolapi.share.zrok.io/api/design-tool/download-image?asset_path=${relativePath}`;

    const link = document.createElement("a");
    link.href = downloadUrl;
    (link as any).download = relativePath.split("/").pop() || "preview.jpg";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div
        className="all-menu-icon"
        onClick={handleClick}
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        {isLoading ? (
          <CircularProgress
            className="circular-progress-action-icon"
            style={{ width: 15, height: 15 }}
          />
        ) : (
          <SubMenuThreeDotIcon />
        )}
      </div>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "basic-button" }}
        className="custom-action-menu"
        PaperProps={{
          elevation: 3,
          sx: {
            borderRadius: "10px",
            mt: 1,
            width: 200,
            boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <MenuItem
          onClick={() => {
            onViewDetails?.();
            handleClose();
          }}
        >
          View/Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            onPreview?.();
            handleClose();
          }}
        >
          Preview
        </MenuItem>
        <MenuItem
          onClick={() => {
            if (previewImageUrl) {
              downloadImagePreview(previewImageUrl);
            }
            handleClose();
          }}
        >
          Download Preview
        </MenuItem>
      </Menu>

      <Modal
        open={modalOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            setModalOpen(false);
          }
        }}
        aria-labelledby="processing-modal"
        className="add-property-modal styled-modal"
        disableEscapeKeyDown
      >
        <div className="modal-center-wrapper">
          <div className="loading-content-wrapper">
            <div className="loading-container">
              <div className="spinner" />
              <p className="loading-text">
                Processing your request
                <span className="desktop-break">
                  <br />
                </span>
                Please wait...
              </p>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ReviewListManuIcon;
